import React,{useRef,useState,useEffect,useContext} from 'react'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Alert,Container,Row,Col,Form,Button,Navbar,NavDropdown,Nav,Table,Modal,Card} from 'react-bootstrap'
import logo from './header.png'

export default function App() {
  const apiUrl='https://api.helexpo.gr/philoxeniaregistrationapi/api/'
  //const apiUrl='http://localhost:3009/philoxeniaregistrationapi/api/'

  const [countries,setCountries]=useState([])
  const [regObj,setRegObj]=useState({})
  const [isRegistered,setIsRegistered]=useState(false)
  const [isLoading,setIsLoading]=useState(false)
  const [gdprAnswer1,setGdprAnswer1]=useState(false)
  const [gdprAnswer2,setGdprAnswer2]=useState(1)
  const [barcode,setBarCode]=useState('')
  const [mailSent,setMailSent]=useState(0)

  const PName=useRef('')
  const Company=useRef('')
  const Job=useRef('')
  const Email=useRef('')
  const City=useRef('')
  const Country=useRef('')
  const CompanyActivity=useRef('')
  const Telephone=useRef('')
  const County=useRef('')



  useEffect(()=>{
    axios.get(apiUrl+'countries').then(res=>{
      setCountries(res.data)
    })
  },[])


  const countriesList=countries.map(item=>{
    return(
      <option selected={item.IsDefault===1 ? true : false} value={item.CountryName}>{item.CountryName} // {item.CountryNameEng}</option>
    )
  })


  const register=(e)=>{
    e.preventDefault()
    setIsLoading(true)
    const xregObj={
      PName:PName.current.value,
      Company:Company.current.value,
      Job:Job.current.value,
      Email:Email.current.value,
      City:City.current.value,
      Country:Country.current.value,
      CompanyActivity:CompanyActivity.current.value,
      Telephone:Telephone.current.value,
      County:'',
      ExCode:'05_2024',
      gdprAnswer1,
      gdprAnswer2,
      token:'hiewf8w7efyhiwehf872398423nddabsdvadytdqw789ey3eeiwqe00231487294'      
    }

    axios.post(apiUrl+'register',xregObj).then(res=>{
      console.log(res.data)
      if (res.data.err==0){
        setRegObj(xregObj)
        setIsRegistered(true)
        setBarCode(res.data.uuidBC)
        setMailSent(res.data.mailSent)
        setIsLoading(false)
      }else{
        alert("Η ΑΠΟΘΚΕΥΣΗ ΔΕΝ ΕΓΙΝΕ, παρακαλούμε προσπαθήστε ξανά")
      }
    })



  }



  return (
    <Container>

      
      <Card>
        <Card.Img variant="top" src={logo} />
        <Card.Body>
          <Card.Title>PHILOXENIA 2024 // Εγγραφή Επισκεπτών // Visitors' Registration</Card.Title>
          <br/><br/>
          
          {isLoading && 
          <Alert variant="warning">Loading, please wait....</Alert>
          
          }


          {!isRegistered && !isLoading &&
          <Form onSubmit={register}>
          <Form.Group className="mb-3">
            <Form.Select required ref={Country}>
              <option value=''>[ΕΠΙΛΕΞΤΕ ΧΩΡΑ // SELECT COUNTRY]</option>
              {countriesList}
            </Form.Select>
          </Form.Group>


          <Form.Group className="mb-3">
              <Form.Label>Ονοματεπώνυμο // Full Name</Form.Label>
              <Form.Control type="text" required ref={PName}/>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Εταιρία // Company</Form.Label>
              <Form.Control type="text" required ref={Company}/>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Αντικείμενο Εταιρίας // Company Activity</Form.Label>
              <Form.Control type="text" required ref={CompanyActivity}/>
            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Θέση στη Εταιρία // Job Description</Form.Label>
              <Form.Control type="text" required ref={Job}/>
            </Form.Group>



            <Form.Group className="mb-3">
              <Form.Label>Πόλη // City</Form.Label>
              <Form.Control type="text" required ref={City}/>
            </Form.Group>
{/* 
            <Form.Group className="mb-3">
              <Form.Label>Νομός // Region</Form.Label>
              <Form.Control type="text" required ref={County}/>
            </Form.Group> */}


            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control type="email" required ref={Email}/>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Τηλέφωνο // Telephone</Form.Label>
              <Form.Control type="text" ref={Telephone}/>
            </Form.Group>



            <div style={{overflow:'auto',backgroundColor:'#fff',marginBottom:'20px',marginTop:'20px',fontSize:'12px'}}>
            <br/><br/>
            <b>ΣΗΜΑΝΤΙΚΗ ΕΝΗΜΕΡΩΣΗ ΣΧΕΤΙΚΑ ΜΕ ΤΑ ΠΡΟΣΩΠΙΚΑ ΣΑΣ ΔΕΔΟΜΕΝΑ</b>
            <br/><br/>
            Η HELEXPO ΔΕΘ λαμβάνει τα δεδομένα σας τα οποία φυλάσσονται σε (ηλεκτρονικό ή/και φυσικό) αρχείο υπ’ ευθύνη της, τηρώντας όλα τα κατάλληλα μέτρα ασφάλειας.
            Σας ενημερώνουμε, ότι θα χρησιμοποιήσουμε τα δεδομένα που σας ζητάμε αποκλειστικά και μόνο για τη διαχείριση και διεκπεραίωση των συμβατικών μας αλλά και εκ του νόμου απορρεουσών υποχρεώσεών μας. Τα δεδομένα αυτά υποχρεούμαστε να διατηρήσουμε για την ελάχιστη περίοδο που απαιτείται από την υπάρχουσα νομοθεσία, ώστε να εκπληρωθούν οι υποχρεώσεις μας προς τρίτα μέρη (συμπεριλαμβανομένων των φορολογικών αρχών) για το χρονικό διάστημα που προβλέπουν οι σχετικές διατάξεις. Εφόσον δεν υφίστανται οι ανωτέρω περιορισμοί, θα διαγράψουμε οριστικά τα δεδομένα σας αφού προηγηθεί σχετική ενημέρωσή σας.
            Έχετε το δικαίωμα πρόσβασης, διόρθωσης και διαγραφής των προσωπικών δεδομένων σας καθώς και το δικαίωμα φορητότητας αυτών προς μεταφορά σε άλλο Υπεύθυνο ή Εκτελούντα Επεξεργασία, αποστέλλοντας σχετικό αίτημά σας στο Τμήμα Τεχνικών Μελετών Έργων και Παρακολούθησης  Πιστοποιήσεων (ISO & GDPR)
            Εγνατία 154 | ΤΚ 546 36 | Θεσσαλονίκη |, ή με email στην ηλεκτρονική διεύθυνση  dpo@helexpo.gr
            Επίσης έχετε το δικαίωμα να αποσύρετε την συγκατάθεσή σας για την επεξεργασία εκ μέρους μας των δεδομένων σας. Στην περίπτωση αυτή παρακαλούμε να έχετε υπόψη σας, ότι μία τέτοια ανάκληση ενδέχεται να σημαίνει αυτομάτως και τη διακοπή της συνεργασίας μας, δεδομένης της αναγκαιότητας της επεξεργασίας των δεδομένων σας για την εκτέλεση των συμβατικών μας υποχρεώσεων. Σε κάθε περίπτωση, ενδέχεται να σας ζητήσουμε τα στοιχεία της ταυτότητάς σας ώστε να βεβαιωθούμε ότι δεν γνωστοποιούμε σε κάποιον άλλον τα προσωπικά σας στοιχεία.
            Θα λάβουμε κάθε δυνατό μέτρο για την ικανοποίηση των αιτημάτων σας εντός τριάντα ημερών από τη λήψη του, ως οφείλουμε, ενημερώνοντάς σας για την ικανοποίηση του αιτήματός σας, ή για τους λόγους που εμποδίζουν την εκ μέρους σας άσκηση ή την ικανοποίηση ενός ή και περισσότερων από τα δικαιώματά σας, καθώς και για τους λόγους τυχόν καθυστέρησής μας πέραν του διαστήματος των τριάντα ημερών. Επίσης θα σας ενημερώσουμε για τα περαιτέρω δικαιώματά σας σε περίπτωση μη προσήκουσας ανταπόκρισής μας στα αιτήματά σας.
            Εφόσον αισθάνεστε ότι θίγονται τα δικαιώματά σας επί των προσωπικών σας δεδομένων, διατηρείτε πάντοτε το δικαίωμα να υποβάλετε παράπονο/καταγγελία στην αρμόδια Εποπτική Αρχή Προστασίας Προσωπικών Δεδομένων: http://www.dpa.gr, Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, τηλ. 210 6475600, email:contact@dpa.gr. Στην περίπτωση αυτή, θα εκτιμούσαμε ιδιαίτερα αν προηγούνταν επικοινωνία σας με τον Υπεύθυνό μας Προστασίας Προσωπικών Δεδομένων (DPO), είτε μέσω αποστολής Φυσικής Επιστολής στην έδρα της εταιρίας (Δ.Ε.Θ.- HELEXPO Α.Ε., ΕΓΝΑΤΙΑΣ 154, 54633), είτε μέσω αποστολής Ηλεκτρονικής Επιστολής (στο λογαριασμό Ηλεκτρονικό Ταχυδρομείο: dpo@helexpo.gr), αναφέροντας πάντοτε τα πλήρη στοιχεία σας και το λόγο επικοινωνίας σας με την εταιρία. Μπορείτε να βρείτε αναλυτικά την Πολιτική μας για την Προστασία Προσωπικών Δεδομένων στον ιστότοπό μας https://www.helexpo.gr/el/GDPR_Policy
            <br/><br/>
            <b>IMPORTANT INFORMATION CONCERNING YOUR PERSONAL DATA</b><br/><br/>
            TIF HELEXPO receives your data which are kept in an (electronic and/or physical) archive under its responsibility, taking all the appropriate security measures.
            We would like to inform you that we will use the data we request solely and exclusively in order to manage and discharge our contractual and legal obligations. We are obligated to retain these data for the minimum period required by the legislation in force in order to discharge our obligations to third parties (including tax authorities) for the period laid down in the relevant provisions. Should the above limitations cease to apply, we will permanently delete your data after having previously notified you.
            You have the right to access, rectification and erasure of your personal data, as well as the right to their portability for transmission to a different Controller or Processor by sending a relevant request to the Technical Studies Project and Monitoring ISO & GDPR Department, or an e-mail message to the address                dpo@helexpo.gr. You also have the right to withdraw your consent for the processing of your data on our part. In this event, please bear in mind that this withdrawal may automatically entail the cessation of our cooperation, given the necessity of processing your data in order to perform our contractual obligations. In any event, we may request your identity data in order to make sure that we are not communicating your personal data to anyone else.
            We will take every possible measure to satisfy your requests within thirty days from receiving them, as we are obligated to do, notifying you of the completion of your request or the reasons hindering the exercise of your rights or the satisfaction of one or more of your rights, as well as the reasons any delay on our part beyond thirty days. Additionally, we will notify you of your further rights in the event of undue response on our part to your requests.
            If you feel that your rights with respect to your personal data are being harmed, you always have the right to lodge a complaint with the competent Supervisory Personal Data Protection Authority: http://www.dpa.gr, 1-3, Kifissias Street, GR-11523, Athens, Tel.: 210 6475600, e-mail: contact@dpa.gr. In this event, we would particularly appreciate your prior communication with our Data Protection Officer (DPO) either by sending a physical letter to the company headquarters (TIF-HELEXPO 154, EGNATIA str, 54636) or by sending an e-mail message (to the e-mail address: dpo@helexpo.gr ), always including your full particulars and the reason for communicating with the company. You can find our Personal Data Protection Policy on our website, https://www.helexpo.gr/en/GDPR_Policy.
            <br/><br/>


            <Alert variant="warning">
            Επιθυμείτε να ενημερώνεστε ηλεκτρονικά ή μέσω ταχυδρομείου, για τη συγκεκριμένη έκθεση, στις διευθύνσεις που δηλώσατε;
            <br/><br/>
            Would you like to receive emails or regular mail, for the specific exhibition, to the above-mentioned addresses?

            <br/><br/>
              <Form.Group className="mb-3">
              <Form.Select required onChange={(e)=>setGdprAnswer1(e.target.value)}>
                <option value=''>[ΠΑΡΑΚΑΛΟΥΜΕ ΑΠΑΝΤΗΣΤΕ // PLEASE ANSWER]</option>
                <option value="1">NAI // YES</option>
                <option value="0">OXI // NO</option>
              </Form.Select>
              </Form.Group>
            </Alert>
            
 



            </div>


            <p align="right">
            <Button disabled={!(gdprAnswer1 && gdprAnswer2)} variant="dark" type="submit" style={{width:'250px',height:'50px'}}>
              Εγγραφή // Register
            </Button>
            </p>
          </Form>
          }  

          {isRegistered && !isLoading &&
          
          <Alert variant="success">
          <Alert.Heading>Η Εγγραφή σας έγινε με επιτυχία!</Alert.Heading>
          <p>
          {mailSent==1 &&
              <>
              Θα παραλάβετε ένα email από το <b>helexpo.services@gmail.com</b> στη διεύθυνση email <b>{regObj.Email}</b><br/> και θέμα <b>PHILOXENIA 2024 // Registration // Παραλαβή Κάρτας Εισόδου</b>.
              <br/><br/>
              Εκεί θα είναι διαθέσιμος ο σύνδεσμος (link) από τον οποίο μπορέιτε να παραλάβετε την κάρτα εισόδου (badge).<br/><br/>

             <i> Εάν δεν φανεί ότι παραλάβατε το email παρακαλούμε να κάνετε έλεγχο και στο spam folder (ανεπιθύμητα) των email σας.</i>
             </>
            }
            {mailSent==0 && 
            <>
            <br/>
            <hr/>

            <b>Την κάρτα εισόδου μπορείτε να την παραλάβετε και απευθείας από &nbsp;
            
            <a href={`https://api.helexpo.gr/philoxenia4/visitorbadge/?badge=${barcode}`} target="_blank">
            ΕΔΩ
            </a>
            </b>
            </>
            }
          </p>

          </Alert>           
          
          
          }

        </Card.Body>
      </Card>





      <>
        <br/><br/><br/>
       <br/><br/><br/>
        <div className="footer">
        
        HELEXPO // PHILOXENIA 2024 // Τμήμα Μηχανογράφησης - 2024
      </div>
    </>
    </Container>
  )
}
